// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getJobDetailsWithBidProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetJobDetailsWithBidProfessionalApi = createAsyncThunk(
  "hitGetJobDetailsWithBidProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getJobDetailsWithBidProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetJobDetailsWithBidProfessionalSlice = createSlice({
  name: "getJobDetailsWithBidProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetJobDetailsWithBidData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetJobDetailsWithBidProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetJobDetailsWithBidProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetJobDetailsWithBidProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetJobDetailsWithBidData } = GetJobDetailsWithBidProfessionalSlice.actions;
export default GetJobDetailsWithBidProfessionalSlice.reducer;
